import { DefaultService } from '@/services/DefaultService';

export default class MoedaService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

    findAllCombo(...params) {
        return this._http.get(encodeURI(`${this._env}/vendas/getcombo/moeda.json?param=${params}`), this._headers).then(res => {
            return res.body;
        },
        err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/vendas/moeda.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	updateSituacao(moeda) {
		return this._http.post(`${this._env}/vendas/moeda/updatesituacao`, moeda, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	find(id) {
		return this._http.get(`${this._env}/vendas/moeda/${id}.json`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	save(form) {
		return this._http.post(`${this._env}/vendas/moeda`, form, this._headers).then(res => {
			return res.body;
		}, err => {
				this.verifyError(err);
				throw err;
			});
		}
}